import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { RiHomeFill } from 'react-icons/ri';
import { IoIosArrowForward } from 'react-icons/io';
import { categories } from '../../utils/data';
import {sideBarStyle} from "../../styles/sideBarStyle";
import {HOME} from "../../constants/routes";

import logo from '../../assets/logo.png';
const CATEGORY_ROUT = '/category/';
const USER_ROUTE = 'user-profile/';
const HOME_TITLE = 'Home';
const CATEGORY_TITLE = 'Discover categories';

const SideBar = ({ user, closeToggle }) => {

    const handleCloseSideBar = () => {
        if (closeToggle) closeToggle(false);
    };

    return (
        <div className={sideBarStyle.sideBar}>
            <div className={sideBarStyle.container}>
                <Link to={HOME}
                      className={sideBarStyle.link}
                      onClick={handleCloseSideBar}
                >
                    <img src={logo} alt="logo" className="w-full" />
                </Link>
                <div className={sideBarStyle.headerLink}>
                    <NavLink to={HOME} className={({ isActive }) => (isActive ? sideBarStyle.isActiveStyle
                        : sideBarStyle.isNotActiveStyle)}
                    >
                        <RiHomeFill />
                        {HOME_TITLE}
                    </NavLink>
                    <h3 className={sideBarStyle.categoryStyle}>{CATEGORY_TITLE}</h3>
                    { categories.slice(0, categories.length - 1).map((category) => (
                        <NavLink to={`${CATEGORY_ROUT}${category.name}`}
                                 key={category.name}
                                 className={({ isActive }) => (isActive ? sideBarStyle.isActiveStyle
                                     : sideBarStyle.isNotActiveStyle)}
                                 onClick={handleCloseSideBar}
                        >
                            <img src={category.image} className={sideBarStyle.image} />
                            {category.name}
                        </NavLink>
                    )) }
                </div>
            </div>
            {user && (
                <Link
                    to={`${USER_ROUTE}${user._id}`}
                    className={sideBarStyle.userLink}
                    onClick={handleCloseSideBar}
                >
                    <img src={user.image} className={sideBarStyle.userImage} alt="user-profile" />
                    <p>{user.userName}</p>
                    <IoIosArrowForward />
                </Link>
            )}
        </div>
    );
};

export default SideBar;
